import { ScrollView, Text, View } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      flex: 1,
      maxHeight: 320,

      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorBorderNeutralDefault,
      borderRadius: theme.borderRadiusForm,

      overflow: 'hidden',

      backgroundColor: theme.colorFillNeutralDefault,
    },
    variants: {},
  }
})

export const List = styled(ScrollView, {
  base: {
    flexGrow: 0,
  },
  variants: {},
})

export const EmptyContainer = styled(View, theme => {
  return {
    base: {
      width: '100%',

      justifyContent: 'center',
      alignItems: 'flex-start',

      paddingVertical: theme.paddingInsetTwopulse,
      paddingHorizontal:
        theme.paddingInsetThreepulse + theme.paddingInsetTwopulse,
    },
    variants: {},
  }
})

export const EmptyText = styled(Text, theme => {
  const fontWeight = String(theme.fontWeightRegular) as FontWeight

  return {
    base: {
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
      color: theme.colorTextNeutralDefault,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      fontWeight,
    },
    variants: {},
  }
})
